//styled components wont work here
// not sure why but don't bother trying to refactor it

const PageTemplate = (props) => {

  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        left: "0.5in",
        width: "calc(100% - 1in)",
        fontSize: "6pt",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <p>{`"${props.title}"`}</p>
      <p>{`STAFF LISTa/o: ${props.time}`}</p>
      <p>{`${props.pageNum}/${props.totalPages}`}</p>
    </div>
  )
}

export default PageTemplate;
